/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormHandles } from '@unform/core';
import produce from 'immer';
import Notiflix from 'notiflix';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { AxiosError, AxiosResponse } from 'axios';
import Button from '../../components/Button';

import Input from '../../components/Input';
import Modal2 from '../../components/Modal2';
import { SelectHandles } from '../../components/Select';
import api from '../../services/api/api';
import { dateToPTBR } from '../../utils/formatt';
import { downloadFileOfBlob } from '../../utils/geterateFileURL';

import {
  ActionsContainer,
  ModalFormWrapper,
  ModalContainer,
  FilesContainer,
  ButtonContainerModal,
  ModalButton,
} from './styles';
import { useAuth } from '../../hooks/auth';
import InputFile, { InputFileHandles } from '../../components/InputFile';
import { getParam, ObjectToUrlParams } from '../../utils/Url';
import { RowProps } from '../Beneficiaries';
import { Row } from './interface';
import { useContract } from '../../hooks/contract';

interface SelectOptionProps {
  value: string;
  title: string;
}

interface DateProps {
  value: Date | null;
  error: string;
}

export const useConsultInclusionOfBeneficiariesController = () => {
  const { colors } = useTheme();
  const { user } = useAuth();
  const history = useHistory();
  const { contract } = useContract();

  const statusRef = useRef<SelectHandles>(null);
  const dateOptionRef = useRef<SelectHandles>(null);
  const cancelRef = useRef<FormHandles>(null);
  const inputFilesRef = useRef<InputFileHandles>(null);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState('');
  const [beneficiary, setBeneficiary] = useState<RowProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [allContracts, setAllContracts] = useState(
    [] as {
      contractId: string;
      productsLength: number;
    }[],
  );

  const [statusOptions, setStatusOptions] = useState<SelectOptionProps[]>([
    {
      title: 'Todos',
      value: '',
    },
  ]);

  const dateUntilSelectOptions = [
    {
      title: 'Ambos',
      value: 'ambos',
    },
    {
      title: 'Somente com lote',
      value: 'comLote',
    },
    {
      title: 'Somente sem lote',
      value: 'semLote',
    },
  ];

  const [selectedFromDate, setSelectedFromDate] = useState<DateProps>({
    value: new Date(
      new Date().getFullYear() - 1,
      new Date().getMonth(),
      new Date().getDate(),
    ),
    error: '',
  });
  const [selectedToDate, setSelectedToDate] = useState<DateProps>({
    value: new Date(),
    error: '',
  });

  const getFiltersToSelect = useCallback(async () => {
    const response = await api.get(
      `/beneficiary-inclusion/inclusion-status-filter`,
    );
    const { data } = response;
    const { content } = data;

    const options = content.map((option: any) => {
      return {
        value: option.id,
        title: option.name,
      };
    });

    setStatusOptions([
      {
        title: 'Todos',
        value: '',
      },
      ...options,
    ]);
  }, []);

  const getBeneficiaryData = useCallback(
    async (controller: AbortController) => {
      try {
        if (!selectedBeneficiary.length) return;
        setIsLoading(true);

        const queryParams = ObjectToUrlParams({
          beneficiaryName: selectedBeneficiary,
        });
        const apiUrl = `/company/list-of-beneficiaries${queryParams}`;

        const allContents: AxiosResponse<any>[] = [];

        const allContractsResps = await Promise.allSettled(
          allContracts.map(({ contractId }) =>
            api.get(`${apiUrl}contractId=${contractId}`, {
              signal: controller.signal,
            }),
          ),
        );

        const allSuccessContractsResp = allContractsResps.filter(
          (resp) => resp.status === 'fulfilled',
        );
        allSuccessContractsResp.forEach((resp) => {
          if (resp.status === 'fulfilled') {
            allContents.push(resp.value);
          }
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const allData: any[] = [];

        allContents.forEach((resp) => {
          const { contractId } = getParam(resp.config.url ?? '');
          const productsLengthOfThisContract = allContracts.find(
            (item) => item.contractId === contractId,
          );

          if (contractId && resp.data.content && productsLengthOfThisContract) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            resp.data.content.forEach((content: any) => {
              allData.push({
                contractId,
                productsLength: productsLengthOfThisContract.productsLength,
                ...content,
              });
            });
          }
        });

        setBeneficiary(allData);
      } catch (error) {
        const err = error as AxiosError<{
          message: string;
        }>;

        console.log(err?.response?.data?.message);
        setBeneficiary([]);
      } finally {
        setIsLoading(false);
      }
    },
    [selectedBeneficiary, allContracts],
  );

  // useEffect(() => {
  //   const controller = new AbortController();

  //   getBeneficiaryData(controller);

  //   return () => {
  //     controller.abort();
  //   };
  // }, [getBeneficiaryData]);

  const [dataTable, setDataTable] = useState([] as Row[]);

  const getDataToTable = useCallback(
    async (filter = [] as string[]) => {
      try {
        Notiflix.Block.circle('.notiflix-table-loading');
        const startDate =
          selectedFromDate.value && dateToPTBR(selectedFromDate.value);
        const finalDate =
          selectedToDate.value && dateToPTBR(selectedToDate.value);

        const params =
          filter.join('&') || `startDate=${startDate}&finalDate=${finalDate}`;

        const { data } = await api.get(
          `/beneficiary-inclusion/consult-records?contractId=${user.contractId}&${params}`,
        );

        setDataTable(data.content);
        return;
      } catch (error) {
        const err = error as AxiosError<{
          message: string;
        }>;

        if (err?.response?.status === 400) {
          setDataTable([]);
        } else {
          Notiflix.Notify.failure(
            'Ops, não conseguimos buscar os dados do servidor... Tente novamente mais tarde.',
          );
        }
      } finally {
        Notiflix.Block.remove('.notiflix-table-loading');
      }
    },
    [user.contractId, selectedFromDate.value, selectedToDate.value],
  );

  const handleSearchDate = useCallback(
    (data) => {
      const filters = [] as string[];
      if (!selectedToDate.value) {
        setSelectedToDate((prev) => ({ ...prev, error: 'Informe uma data.' }));
        return;
      }
      if (!selectedFromDate.value) {
        setSelectedFromDate((prev) => ({
          ...prev,
          error: 'Informe uma data.',
        }));
        return;
      }
      filters.push(`startDate=${dateToPTBR(selectedFromDate.value)}`);
      filters.push(`finalDate=${dateToPTBR(selectedToDate.value)}`);
      if (statusRef.current?.value) {
        filters.push(`status=${statusRef.current.value}`);
      }
      if (dateOptionRef.current?.value) {
        filters.push(`timeInterval=${dateOptionRef.current.value}`);
      }
      if (data.batch) {
        filters.push(`batch=${data.batch}`);
      }
      if (data.requestId) {
        filters.push(`requestId=${data.requestId}`);
      }
      if (data.beneficiaryName) {
        filters.push(`beneficiaryName=${data.beneficiaryName}`);
      }

      getDataToTable(filters);
    },
    [getDataToTable, selectedFromDate.value, selectedToDate.value],
  );

  useEffect(() => {
    if (user.contractId) {
      getFiltersToSelect();
      getDataToTable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleOpenInfoRejected = useCallback((data: Row) => {
    Modal2.Warning({
      closable: true,
      autoWidth: true,
      title: 'Motivo',
      subtitle: data.reasonForDisapproval ?? '',
      text: data.observation ?? '',
      children: (
        <Button modal onClick={() => Modal2.Close()}>
          Ok
        </Button>
      ),
    });
  }, []);

  const handleOpenDetailRejected = useCallback(
    (data: Row) => {
      history.push(
        `/incluir-beneficiario/${data.requestId}/rejeitado/${
          data.inclusionType === 1 ? 'titular' : 'dependente'
        }/${data.holderName ?? ''}`,
      );
    },
    [history],
  );

  const handleRelease = useCallback(async (row: Row) => {
    try {
      Notiflix.Block.circle(`.notiflix-release-${row.requestId}`);
      const { data } = await api.put(`company/release-dependent-registered`, {
        requestId: row.requestId,
      });
      const { message } = data;
      Modal2.Success({
        closable: true,
        autoWidth: true,
        title: 'Perfeito!',
        text: message,
        children: (
          <Button modal onClick={() => Modal2.Close()}>
            Ok
          </Button>
        ),
      });
      getDataToTable();
      setDataTable((prev) =>
        produce(prev, (draft) => {
          const found = draft.find((i) => i.requestId === row.requestId);
          if (found) {
            found.status = 'Aguardando análise Operadora';
          }
        }),
      );
    } catch (error) {
      const err = error as AxiosError<{
        message: string;
      }>;

      if (err.response?.data?.message) {
        Modal2.Failure({
          closable: true,
          autoWidth: true,
          title: 'Ooops...',
          text: err.response.data.message,
          children: (
            <Button modal onClick={() => Modal2.Close()}>
              Ok
            </Button>
          ),
        });
      } else {
        Notiflix.Notify.failure(
          'Ops... Não conseguimos enviar sua solicitação para o servidor. Por favor, tente novamente mais tarde.',
        );
      }
    } finally {
      Notiflix.Block.circle(`.notiflix-release-${row.requestId}`);
    }
  }, []);

  const handleUndoRelease = useCallback(
    async (row: Row) => {
      try {
        Notiflix.Block.circle(`.notiflix-release-${row.requestId}`);
        const resp = localStorage.getItem('@unimedLitoral');
        if (resp) {
          const userData = JSON.parse(resp);
          const { webUsername } = userData;
          const { data } = await api.put(
            `/beneficiary-inclusion/undo-release-solicitation-request`,
            {
              contractId: user.contractId,
              requestId: row.requestId,
              webUsername,
            },
          );
          const { message } = data;
          Modal2.Success({
            closable: true,
            autoWidth: true,
            title: 'Perfeito!',
            text: message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
          getDataToTable();
          setDataTable((prev) =>
            produce(prev, (draft) => {
              const found = draft.find((i) => i.requestId === row.requestId);
              if (found) {
                found.status = 'Aguardando liberação';
              }
            }),
          );
        }
      } catch (error) {
        const err = error as AxiosError<{
          message: string;
        }>;

        if (err.response?.data?.message) {
          Modal2.Failure({
            closable: true,
            autoWidth: true,
            title: 'Ooops...',
            text: err.response.data.message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
        } else {
          Notiflix.Notify.failure(
            'Ops... Não conseguimos enviar sua solicitação para o servidor. Por favor, tente novamente mais tarde.',
          );
        }
      } finally {
        Notiflix.Block.circle(`.notiflix-release-${row.requestId}`);
      }
    },
    [user.contractId, getDataToTable],
  );

  const handleOpenDetailAndEdit = useCallback(
    (data) => {
      history.push(
        `/incluir-beneficiario/${data.requestId}/edicao/${
          data.inclusionType === 1 ? 'titular' : 'dependente'
        }/${data.holderName ?? ''}`,
      );
    },
    [history],
  );
  const handleOpenReport = useCallback(async (data: Row) => {
    try {
      Notiflix.Block.circle(`.notiflix-report-${data.requestId}`);
      const { data: dataApi } = await api.get(
        '/report/list-of-company-portal-reports?exhibitionLocation=2',
      );
      const { content } = dataApi;
      const { nrSeqRelatorio, Parametros: P } = content[0];

      const { data: dataReport } = await api.post(
        `/report/generate-report`,
        {
          nrSeqRelatorio: nrSeqRelatorio ?? '',
          Parametros: [
            {
              id: P[0].cdParametro,
              valor: data.requestId,
            },
          ],
        },
        {
          responseType: 'blob',
        },
      );
      downloadFileOfBlob(dataReport);
    } catch (error) {
      const err = error as AxiosError<{
        message: string;
      }>;

      if (err.response?.data?.message) {
        Notiflix.Notify.info(err.response.data.message);
      } else {
        Notiflix.Notify.failure(
          'Ops... Não conseguimos buscar o relatório no servidor. Por favor, tente novamente mais tarde.',
        );
      }
    } finally {
      Notiflix.Block.remove(`.notiflix-report-${data.requestId}`);
    }
  }, []);

  const handleOpenInconsistency = useCallback(async (row: Row) => {
    try {
      Notiflix.Block.circle('notiflix-button');
      const { data } = await api.get(
        `/company/get-inconsistency-inclusion?requestNumber=${row.requestId}`,
      );

      const { data: realData } = data;
      const text = realData.map((e: any) => {
        return <p>{e.inconsistencyDescription}</p>;
      });

      if (!data) {
        return;
      }

      Modal2.Generic({
        closable: true,
        title: 'Inconsistências',
        autoWidth: true,
        text,
      });
    } catch (err: any) {
      if (err.response?.data?.message) {
        Notiflix.Notify.info(err.response.data.message);
      } else {
        Notiflix.Notify.failure(
          'Ops... Não conseguimos buscar o relatório no servidor. Por favor, tente novamente mais tarde.',
        );
      }
    } finally {
      Notiflix.Block.remove('notiflix-button');
    }
  }, []);

  const handleCancelRegister = useCallback(async (row: Row) => {
    try {
      Notiflix.Block.circle(`.notiflix-cancel-${row.requestId}`);
      const submitCancel = async (form: any) => {
        try {
          Notiflix.Block.circle('.notifix-modal-cancel');

          if (!cancelRef.current?.getFieldValue('observation')) {
            cancelRef.current?.setFieldError(
              'observation',
              'É necessário informar a observação',
            );
            return;
          }
          cancelRef.current?.setFieldError('observation', '');

          const { data } = await api.put(
            `/beneficiary-inclusion/cancel-inclusion-request`,
            {
              observation: form.observation,
              requestId: row.requestId,
            },
          );
          const { message } = data;
          Modal2.Close();
          Modal2.Success({
            closable: true,
            autoWidth: true,
            title: 'Perfeito!',
            text: message,
            children: (
              <Button modal onClick={() => Modal2.Close()}>
                Ok
              </Button>
            ),
          });
          setDataTable((prev) =>
            produce(prev, (draft) => {
              const founded = draft.find((i) => i.requestId === row.requestId);
              if (founded) {
                founded.status = 'Solicitação cancelada';
              }
            }),
          );
        } catch (error) {
          const err = error as AxiosError<{
            message: string;
          }>;
          Modal2.Close();
          if (err.response?.data?.message) {
            Modal2.Failure({
              closable: true,
              autoWidth: true,
              title: 'Ooops...',
              text: err.response.data.message,
              children: (
                <Button modal onClick={() => Modal2.Close()}>
                  Ok
                </Button>
              ),
            });
          } else {
            Notiflix.Notify.failure(
              'Ops... Não conseguimos enviar sua solicitação de cancelamento para o servidor. Por favor, tente novamente mais tarde.',
            );
          }
        } finally {
          Notiflix.Block.remove('.notifix-modal-cancel');
        }
      };
      Modal2.Warning({
        closable: true,
        autoWidth: true,
        title: 'Cancelar Registro',
        children: (
          <ModalFormWrapper onSubmit={submitCancel} formLook ref={cancelRef}>
            <Input name="observation" title="Observação" formLook />
            <Button modal autoWidth secondary onClick={() => Modal2.Close()}>
              Voltar
            </Button>
            <Button
              modal
              type="submit"
              autoWidth
              className="notifix-modal-cancel"
            >
              Enviar
            </Button>
          </ModalFormWrapper>
        ),
      });
    } catch (error) {
      const err = error as AxiosError<{
        message: string;
      }>;

      if (err.response?.data?.message) {
        Notiflix.Notify.failure(err.response.data.message);
      } else {
        Notiflix.Notify.failure(
          'Ops... Não conseguimos cancelar o registro no servidor. Por favor, tente novamente mais tarde.',
        );
      }
    } finally {
      Notiflix.Block.remove(`.notiflix-cancel-${row.requestId}`);
    }
  }, []);

  const [rowExpanded, setRowExpanded] = useState([] as Row[]);

  const handleOpenAttachment = useCallback(
    async (archive, requestId, notiflix) => {
      try {
        Notiflix.Block.circle(notiflix);
        const { data } = await api.get(
          `/beneficiary-inclusion/attachment-sent-in-inclusion?requestId=${requestId}&fileId=${archive.id}&fileName=${archive.name}`,
          {
            responseType: 'blob',
          },
        );
        downloadFileOfBlob(data);
      } catch (error) {
        const err = error as AxiosError<{
          message: string;
        }>;

        if (err.response?.data?.message) {
          Notiflix.Notify.failure(err.response.data.message);
        } else {
          Notiflix.Notify.failure(
            'Ops... Não conseguimos buscar seu documento. Por favor, tente novamente mais tarde',
          );
        }
      } finally {
        Notiflix.Block.remove(notiflix);
      }
    },
    [],
  );

  const handleViewAndAttachLineOption = useCallback(
    async (row: Row, notiflix: string) => {
      try {
        Notiflix.Block.circle(notiflix, { svgSize: '0.8rem' });
        let attachments = [] as { id: number; name: string }[];
        try {
          const { data } = await api.get(
            `/beneficiary-inclusion/consult-solicitation-for-editing?requestId=${row.requestId}`,
          );
          const { content } = data;
          attachments = content[0].attachments;
        } catch (e) {
          Notiflix.Notify.info('Ainda não há anexos.');
        }

        const addAttachment = async () => {
          if (!inputFilesRef.current?.files) return;
          try {
            Notiflix.Block.circle('.notiflix-send-attachment');
            const params = new FormData();
            params.append('webUsername', user.webUsername);
            params.append('requestId', row.requestId.toString());
            params.append('file', inputFilesRef.current.files[0]);
            const { data: data2 } = await api.post(
              `/beneficiary-inclusion/send-attachments-for-inclusion`,
              params,
            );
            const { message } = data2;
            Notiflix.Notify.success(message);
            Modal2.Close();
            handleViewAndAttachLineOption(row, notiflix);
          } catch (error) {
            const err = error as AxiosError<{
              message: string;
            }>;

            if (err.response?.data?.message) {
              Notiflix.Notify.failure(err.response.data.message);
            } else {
              Notiflix.Notify.failure(
                'Ops... Não conseguimos enviar seu arquivo para o servidor. Por favor, tente novamente mais tarde.',
              );
            }
          } finally {
            Notiflix.Block.remove('.notiflix-send-attachment');
          }
        };

        Modal2.Generic({
          children: (
            <ModalContainer>
              <h2>Informações dos arquivos</h2>
              <FilesContainer>
                {attachments.map((archive) => (
                  <button
                    type="button"
                    key={archive.id}
                    onClick={() =>
                      handleOpenAttachment(
                        archive,
                        row.requestId,
                        `.notiflix-archive-${archive.id}`,
                      )
                    }
                    className={`notiflix-archive-${archive.id}`}
                  >
                    {archive.name}
                  </button>
                ))}
              </FilesContainer>

              {row.allowEdit === 'S' && (
                <ButtonContainerModal>
                  <InputFile placeholder="Anexar arquivo" ref={inputFilesRef} />
                  <ModalButton
                    modal
                    onClick={addAttachment}
                    className="notiflix-send-attachment"
                  >
                    Enviar Anexo
                  </ModalButton>
                </ButtonContainerModal>
              )}
            </ModalContainer>
          ),
          autoWidth: true,
          closable: true,
        });
      } catch (error) {
        Notiflix.Notify.failure(
          'Ops... Não conseguimos buscar os dados do servidor.Por favor, tente novamente mais tarde.',
        );
      } finally {
        Notiflix.Block.remove(notiflix);
      }
    },
    [handleOpenAttachment, user],
  );

  const handleIncludeDependent = useCallback(() => {
    if (!beneficiary.length) {
      Notiflix.Notify.failure(
        'É necessário selecionar um beneficiário válido para incluir dependentes.',
      );

      return;
    }

    setStep(2);
  }, [beneficiary]);

  const templateRowExpanded = useCallback(
    (rowData: Row) => {
      return (
        <ActionsContainer>
          {rowData.status !== 'Solicitação com inconsistência' && (
            <Button
              sausageLook
              whiteButton
              autoWidth
              onClick={() => handleOpenReport(rowData)}
              className={`notiflix-report-${rowData.requestId}`}
            >
              Relatório
            </Button>
          )}
          <Button
            sausageLook
            whiteButton
            autoWidth
            onClick={() =>
              handleViewAndAttachLineOption(
                rowData,
                `.notiflix-attachment-${rowData.requestId}`,
              )
            }
            className={`notiflix-attachment-${rowData.requestId} marginRight`}
          >
            {rowData.allowEdit === 'S' ? 'Ver / Anexar' : 'Ver anexos'}
          </Button>

          {rowData.disapproved === 'S' && (
            <>
              <Button
                sausageLook
                whiteButton
                autoWidth
                onClick={() => handleOpenInfoRejected(rowData)}
                className={`notiflix-reject-${rowData.requestId}`}
              >
                Motivo de rejeição
              </Button>
              <Button
                sausageLook
                whiteButton
                autoWidth
                onClick={() => handleOpenDetailRejected(rowData)}
                className={`notiflix-reject-${rowData.requestId}`}
              >
                Refazer inclusão
              </Button>
            </>
          )}

          {rowData.status === 'Solicitação com inconsistência' && (
            <Button
              sausageLook
              whiteButton
              autoWidth
              onClick={() => handleOpenInconsistency(rowData)}
            >
              Inconsistências
            </Button>
          )}
          {rowData.status === 'Aguardando liberação' && (
            <Button
              sausageLook
              whiteButton
              autoWidth
              onClick={() => handleRelease(rowData)}
            >
              Liberar
            </Button>
          )}
          {rowData.allowUndoRequest === 'S' &&
            rowData.status === 'Aguardando análise Operadora' && (
              <Button
                sausageLook
                whiteButton
                autoWidth
                onClick={() => handleUndoRelease(rowData)}
              >
                Desfazer Liberação
              </Button>
            )}
          {rowData.allowEdit === 'S' && (
            <Button
              sausageLook
              whiteButton
              autoWidth
              onClick={() => handleOpenDetailAndEdit(rowData)}
            >
              Editar
            </Button>
          )}
          {/* row.ownership === 'Titular' && row.situation === 'Ativo' */}
          {rowData.status !== 'Contratação concluída' &&
            rowData.status !== 'Solicitação cancelada' && (
              <Button
                sausageLook
                whiteButton
                autoWidth
                onClick={() => handleCancelRegister(rowData)}
                className={`notiflix-cancel-${rowData.requestId}`}
              >
                Cancelar
              </Button>
            )}
          {/* <Button
            sausageLook
            whiteButton
            autoWidth
            onClick={handleIncludeDependent}
            className={`notiflix-cancel-${rowData.requestId}`}
            disabled={!beneficiary.length || isLoading}
          >
            Incluir Dependentes
          </Button> */}
        </ActionsContainer>
      );
    },
    [
      handleOpenReport,
      handleViewAndAttachLineOption,
      handleOpenInfoRejected,
      handleOpenDetailRejected,
      handleOpenInconsistency,
      handleRelease,
      handleUndoRelease,
      handleOpenDetailAndEdit,
      handleCancelRegister,
      // handleIncludeDependent,
      // isLoading,
      // beneficiary,
    ],
  );

  const getAllContractsAndProducts = useCallback(async () => {
    try {
      Notiflix.Block.circle('.notiflix-table-beneficiaries');
      const contracts = [];
      // if (user.groupNumber) {
      //   const { data: dataContracts } = await api.get(
      //     `/company/list-of-contracts?groupNumber=${user.groupNumber}`,
      //   );
      //   const { content: contentContracts } = dataContracts;
      //   contentContracts.forEach((item: { contractId: string }) => {
      //     contracts.push(item.contractId);
      //   });
      // } else {
      contracts.push(contract.contractId);
      // }

      const contractsAndProducts = [] as {
        contractId: string;
        productsLength: number;
      }[];
      const allProductsResp = await Promise.allSettled(
        contracts.map((ct) =>
          api.get(`/company/product-listing-for-selection?contractId=${ct}`),
        ),
      );
      const allProductsSuccess = allProductsResp.filter(
        (p) => p.status === 'fulfilled',
      );

      allProductsSuccess.forEach((productReps) => {
        if (productReps.status === 'fulfilled') {
          const { contractId } = getParam(productReps.value.config.url ?? '');
          if (contractId) {
            contractsAndProducts.push({
              contractId,
              productsLength: productReps.value.data?.content?.length ?? 0,
            });
          }
        }
      });
      setAllContracts(contractsAndProducts);
    } catch (err) {
      Notiflix.Block.remove('.notiflix-table-beneficiaries');
      Notiflix.Notify.failure(
        'Ops... Algo deu errado ao tentar obter seus contratos e produtos... Tente novamente mais tarde.',
      );
    }
  }, [contract]);

  useEffect(() => {
    // getInitialStipulatedBondOptions();
    if (contract.contractId) {
      getAllContractsAndProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract]);

  return {
    statusOptions,
    dateUntilSelectOptions,
    dataTable,
    templateRowExpanded,
    setRowExpanded,
    rowExpanded,
    setSelectedBeneficiary,
    handleSearchDate,
    setSelectedFromDate,
    setSelectedToDate,
    selectedFromDate,
    selectedToDate,
    statusRef,
    colors,
    handleIncludeDependent,
    step,
    setStep,
    beneficiary,
    isLoading,
    setBeneficiary,
  };
};
